import initVueApp from "@/core.js";
const component = require(`./../views/Headless.vue`).default;
initVueApp(component);
